export default __webpack_public_path__ + "static/media/white-3.a2939496.png";